/* eslint formatjs/no-literal-string-in-jsx: "error" */

import { FormSelectOption } from "@carrotfertility/carotene-core-x"
import { useIntl } from "react-intl"
import { useSelector } from "react-redux"
import { getBenefitConfiguration } from "reducers/benefitConfiguration"

export function useGetSexOptions(): FormSelectOption[] {
  const benefitConfiguration = useSelector(getBenefitConfiguration)
  const intl = useIntl()
  return [
    { label: intl.formatMessage({ defaultMessage: "Male" }), value: "MALE" },
    { label: intl.formatMessage({ defaultMessage: "Female" }), value: "FEMALE" },
    {
      label: intl.formatMessage({ defaultMessage: "Intersex" }),
      value: "INTERSEX",
      filter: (c) => c.featureConfig.isLgtbqEnabled
    }
  ].filter((c) => !c.filter || c.filter(benefitConfiguration))
}
